// Mobilny overlay z zakładkami: Kategorie, O nas
// @ts-nocheck

import React, { FC, useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { X } from 'react-bootstrap-icons';

import CategoryTree from 'components/layouts/MainLayout/components/HeaderBottomBar/components/CategoryTree/CategoryTree';
import MobileNavigationLinks from 'components/containers/MobileNavigationOverlay/components/MobileNavigationLinks/MobileNavigationLinks';
import logo from 'assets/logo.svg';

import styles from 'theme/components/containers/MobileNavigationOverlay/MobileNavigationOverlay.module.scss';

interface IProps {
  close: () => void;
  initialTab?: TabType;
}

type TabType = 'categories' | 'about';

const MobileNavigationOverlay: FC<IProps> = ({
  close,
  initialTab = 'categories'
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<TabType>(initialTab);
  const [isSubcategoriesViewOpen, setIsSubcategoriesViewOpen] = useState(false);

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Containers-MobileNavigationOverlay'
      )}>
      {/* Biały panel z zawartością */}
      <div className={styles.panel}>
        {/* Header z logo */}
        <div className={styles.header}>
          <div className={styles.logo}>
            <img src={logo} alt="logo" />
          </div>
          <button className={styles.closeButton} onClick={close}>
            <X />
          </button>
        </div>

        {/* Zakładki - ukryte gdy widok podkategorii jest otwarty */}
        {!isSubcategoriesViewOpen && (
          <div className={styles.tabs}>
            <button
              className={classnames(styles.tab, {
                [styles.active]: activeTab === 'categories'
              })}
              onClick={() => setActiveTab('categories')}>
              {t('Kategorie')}
            </button>
            <button
              className={classnames(styles.tab, {
                [styles.active]: activeTab === 'about'
              })}
              onClick={() => setActiveTab('about')}>
              {t('O nas')}
            </button>
          </div>
        )}

        {/* Zawartość zakładki */}
        <div className={styles.content}>
          {activeTab === 'categories' && (
            <div className={styles.categoriesWrapper}>
              <CategoryTree 
                onCategoryClick={close} 
                onSubcategoriesViewChange={setIsSubcategoriesViewOpen}
              />
            </div>
          )}

          {activeTab === 'about' && (
            <div className={styles.aboutWrapper}>
              <MobileNavigationLinks 
                onLinkClick={close}
                onSubcategoriesViewChange={setIsSubcategoriesViewOpen}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileNavigationOverlay;

